module.exports = __webpack_public_path__ + "assets/img/1.f3e4ce85.png";